import get from 'lodash/get'
import React from 'react'
import Helmet from 'react-helmet'
import { siteMetadata } from '../../gatsby-config'

// imgs
import ImgSavasa from '../images/foto-savasa.jpg'
import Produto1 from '../images/Produtos/foto-1.jpg'
import Produto5 from '../images/Produtos/foto-5.jpg'
import Produto3 from '../images/Produtos/foto-3.jpg'
import Produto4 from '../images/Produtos/foto-4.jpg'

import { Row, Col, Container, Button } from 'reactstrap'

import bgSobreImg from '../images/bg-pag-interna.2742da36.jpg'
import listMarkerImg from '../images/Sobre/list-marker.svg'
import './sobre.scss'
export default function Sobre () {
  return (
    <div>
      <Helmet
        title={`${get(siteMetadata, 'title')} - Sobre`}
        meta={[
          { name: 'author', content: get(siteMetadata, 'author') },
          {
            name: 'description',
            content:
              'Pioneira dos avanços do setor de rótulos nos último anos é líder em inovação, qualidade e serviço. Compromisso no desenvolvimento de rótulos de valor agregado. Potente estrutura de produção. Rotogravura, Flexografia, Laboratório.'
          },
          {
            name: 'keywords',
            content:
              'Savasa impressores, rótulo, soluções de rótulos, gráfica de rótulo, desenvolvimento de rótulos, inovação, pioneira, líder em inovação, Rotogravura, Flexografia, Laboratório.'
          },
          { property: 'og:title', content: get(siteMetadata, 'title') },
          { property: 'og:type', content: 'website' },
          {
            property: 'og:description',
            content:
              'Pioneira dos avanços do setor de rótulos nos último anos é líder em inovação, qualidade e serviço. Compromisso no desenvolvimento de rótulos de valor agregado. Potente estrutura de produção. Rotogravura, Flexografia, Laboratório.'
          },
          {
            property: 'og:url',
            content: `${get(siteMetadata, 'siteUrl')}`
          },
          {
            property: 'og:image',
            content: `${get(
              siteMetadata,
              'siteUrl'
            )}/favicon/android-icon-512x512.png`
          }
        ]}
      />
      <Container fluid className="text-center">
        <Row className="py-3">
          <Col xs="12">
            <div className="fc-E66827">
              <h2
                className="mt-4 text-center"
                style={{ letterSpacing: '10px' }}
              >
                SAVASA IMPRESSORES
              </h2>
              <h2
                className="mt-3 text-center font-weight-bold"
                style={{ letterSpacing: '10px' }}
              >
                25 ANOS INOVANDO
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row
          style={{
            backgroundColor: '#ec5110'
          }}
        >
          <Col
            xs="12"
            md="12"
            lg="6"
            className=" text-center"
            style={{
              backgroundColor: '#ec5110',
              padding: '0px',
              margin: 'auto'
            }}
          >
            <img
              src={ImgSavasa}
              className="img-fluid"
            />
          </Col>
          <Col xs="12" md="12" lg="6" className="bg-005A9C">
            <h3
              className="pt-5 pb-3 px-2 text-white"
              style={{ letterSpacing: '10px' }}
            >
              “O rótulo, <br className="d-none d-md-block" /> nosso
              compromisso”
            </h3>
            <p className="pb-5 px-2 text-white">
              Desde sua fundação em 1997, os profissionais da{' '}
              <span className="font-weight-bold">
                {' '}
                Savasa <br className="d-none d-md-block" />
                Impressores Ltda.{' '}
              </span>{' '}
              tem dedicado todos seus esforços para uma única{' '}
              <br className="d-none d-md-block" />
              atividade: criar rótulos de valor agregado, oferecendo soluções{' '}
              <br className="d-none d-md-block" />
              inovadoras aos clientes. <br />
              <br />
              Este esforço constante permitiu desenvolver uma especialização{' '}
              <br className="d-none d-md-block" />
              exclusiva que promoveu a{' '}
              <span className="font-weight-bold"> SAVASA </span> ao posto de
              pioneira de grande <br className="d-none d-md-block" />
              parte dos avanços obtidos no setor nos últimos anos. Por isso
              sua <br className="d-none d-md-block" />
              constante preocupação em manter a liderança no mercado por sua{' '}
              <br className="d-none d-md-block" />
              qualidade, inovação e serviço. <br />
              <br />
              Em 2022 a <span className="font-weight-bold">
                {' '}
                SAVASA{' '}
              </span>{' '}
              completou 25 anos e queremos levar aos nossos{' '}
              <br className="d-none d-md-block" />
              clientes o mesmo conceito e entusiasmo, aliado a um forte <br />
              compromisso. <br />
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col xs="12" className="bg-E66827 text-center p-0">
            <img src={bgSobreImg} className="img-fluid" />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col xs="12">
            <h2
              className="my-5 text-center fc-005A9C"
              style={{ letterSpacing: '10px' }}
            >
              CRESCEMOS <span className="font-weight-bold"> COM VOCÊ </span>
            </h2>
            <p className="pb-3 px-2">
              Savasa Impressores Ltda. conta com uma potente estrutura de
              produção, com capacidade e versatilidade para garantir
              flexibilidade no atendimento aos clientes.
              <br />
              <br />
              Localizada em Mogi das Cruzes, a fábrica possui:
            </p>
            <ul
              style={{
                listStyleImage: 'url(' + listMarkerImg + ')',
                backgroundColor: '#005a9c',
                color: 'white'
              }}
            >
              <li className="py-2">
                Impressão em rotogravura de até 8 cores frente e verso;
              </li>
              <li className="py-2">
                Impressão em Offset de até 7 cores com U.V.;
              </li>
              <li className="py-2">
                Ampla linha de acabamento com guilhotinas e troqueladoras;
              </li>
              <li className="py-2">Laboratório equipado;</li>
            </ul>
          </Col>
        </Row>
      </Container>

      <div className="bg-F8F8F8">
        <Container fluid style={{ maxWidth: '800px' }}>
          <Row className="text-center py-5">
            <Col xs="6" className="p-3 text-right">
              <img
                src={Produto1}
                className="img-fluid"
              />
            </Col>
            <Col xs="6" className="p-3 text-left">
              <img
                src={Produto5}
                className="img-fluid"
              />
            </Col>
            <Col xs="6" className="p-3 text-right">
              <img
                src={Produto3}
                className="img-fluid"
              />
            </Col>
            <Col xs="6" className="p-3 text-left">
              <img
                src={Produto4}
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-gradient-orange">
        <Container>
          <Row className="text-center py-3">
            <Col xs="12" className="p-3 text-right">
              <Button
                href="/orcamento"
                outline
                color="secondary"
                size="lg"
                block
              >
                SOLICITE UM ORÇAMENTO
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}
